import React from 'react';
import PropTypes from 'prop-types';

import Helmet from 'react-helmet';

import LoginFormView from './View';

function Login(props, context) {
    const { content, router } = context;

    return (
        <div className="login">
            <Helmet title={content.title} />
            <LoginFormView location={props.location} />
        </div>
    );
}

Login.contextTypes = {
    config: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired,
    router: PropTypes.object,
};

export default Login;
